import React from 'react'
import { useForm } from '@inertiajs/inertia-react'
import Breadcrumbs from '../../../Shared/Components/Breadcrumbs'
import Layout from '../../../Shared/Layout/LayoutAdmin'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { SIA_NAVY } from '../../../constants/siaTheme'
import ReportCard from './ReportCard'

function formatDisplayDate(iso) {
    if (!iso) return ''
    const [y, m, d] = String(iso).slice(0, 10).split('-')
    if (!y) return iso
    return `${d}/${m}/${y}`
}

const RecruitmentReports = ({ cards, filters }) => {
    const filterForm = useForm({
        fecha_inicio: filters.fecha_inicio || '',
        fecha_fin: filters.fecha_fin || '',
        tipo_fecha: filters.tipo_fecha || 'registro',
    })

    const pathPrefix = 'admin/reclutamiento/reportes'

    const submit = (e) => {
        e.preventDefault()
        filterForm.get(route('recruitment.reports'), { preserveState: true })
    }

    const hasRange = filters.fecha_inicio && filters.fecha_fin
    const tipoLabel = filters.tipo_fecha === 'entrevista' ? 'fecha de entrevista' : 'fecha de registro'

    return (
        <Row>
            <span className="pb-7 pt-7">
                <Breadcrumbs currentPath={pathPrefix} />
            </span>

            <div className="card card-flush shadow-sm mb-8">
                <div className="card-body py-6 px-6">
                    <Form onSubmit={submit} className="row g-4 align-items-end">
                        <Col md={3}>
                            <Form.Label className="fw-bold fs-7">Filtrar por</Form.Label>
                            <Form.Select
                                value={filterForm.data.tipo_fecha}
                                onChange={(e) => filterForm.setData('tipo_fecha', e.target.value)}
                            >
                                <option value="registro">Fecha de registro</option>
                                <option value="entrevista">Fecha de entrevista</option>
                            </Form.Select>
                        </Col>
                        <Col md={3}>
                            <Form.Label className="fw-bold fs-7">Fecha inicial</Form.Label>
                            <Form.Control
                                type="date"
                                value={filterForm.data.fecha_inicio}
                                onChange={(e) => filterForm.setData('fecha_inicio', e.target.value)}
                            />
                        </Col>
                        <Col md={3}>
                            <Form.Label className="fw-bold fs-7">Fecha final</Form.Label>
                            <Form.Control
                                type="date"
                                value={filterForm.data.fecha_fin}
                                onChange={(e) => filterForm.setData('fecha_fin', e.target.value)}
                            />
                        </Col>
                        <Col md={3}>
                            <Button type="submit" variant="primary" className="w-100" disabled={filterForm.processing}>
                                Consultar
                            </Button>
                        </Col>
                    </Form>
                </div>
            </div>

            {hasRange && (
                <div
                    className="rounded-2 mb-8 py-4 px-4 text-center text-white text-uppercase fw-bold fs-4"
                    style={{ backgroundColor: SIA_NAVY, letterSpacing: '0.04em' }}
                >
                    Resumen de reclutamiento {formatDisplayDate(filters.fecha_inicio)} – {formatDisplayDate(filters.fecha_fin)}
                    <div className="fs-7 fw-normal mt-1 opacity-90">Por {tipoLabel}</div>
                </div>
            )}

            {hasRange && cards.length === 0 && (
                <div className="text-center text-gray-600 py-15">No hay datos en el rango seleccionado.</div>
            )}

            {hasRange && cards.length > 0 && (
                <Row className="g-6">
                    {cards.map((card) => (
                        <Col key={`${card.recruiter_name}-${card.location}`} md={6} lg={4}>
                            <ReportCard card={card} />
                        </Col>
                    ))}
                </Row>
            )}

            {!hasRange && (
                <div className="text-center text-gray-600 py-15">Seleccione fecha inicial y final, luego pulse Consultar.</div>
            )}
        </Row>
    )
}

RecruitmentReports.layout = (page) => <Layout title="Reportes de reclutamiento">{page}</Layout>

export default RecruitmentReports
